import Immutable from 'immutable'
import moment from 'moment'
import { apiHandleStatus, billingPeriod, jsonParse } from '../../lib/index'

import MainReducer from '../main/reducer'
import capiSingleton from '../../api/carrotApi'
const capi = capiSingleton.get()

const TYPES = {
    CLEAR: 'DASHBOARD_CLEAR',
    SET_LOADING: 'DASHBOARD_SET_LOADING',
    SET_ERROR: 'DASHBOARD_SET_ERROR',
    SET_TRANSACTIONS: 'DASHBOARD_SET_TRANSACTIONS',
    SET_OFFSET_KEY_DATE: 'DASHBOARD_SET_OFFSET_KEY_DATE',
    SET_NO_TRANSACTIONS: 'DASHBOARD_SET_NO_TRANSACTIONS'
}

export default class DashboardReducer {
    static componentName = 'DashboardReducer'
    static NAME = 'dashboard_reducer'
    static TYPES = TYPES
    static INITIAL_STATE = Immutable.fromJS({})

    static clear() {
        return (dispatch, getState) => dispatch({ type: TYPES.CLEAR })
    }

    static setLoading() {
        return (dispatch, getState) => {
            dispatch({
                type: TYPES.SET_LOADING
            })
        }
    }

    static setError(
        error
    ) {
        return (dispatch, getState) => {
            dispatch({
                type: TYPES.SET_ERROR,
                error
            })
        }
    }

    static setOffsetKeyDate(
        data
    ) {
        return (dispatch, getState) => {
            dispatch({
                type: TYPES.SET_OFFSET_KEY_DATE,
                data
            })
        }
    }

    static setTransactions(
        transactions
    ) {
        return (dispatch, getState) => {
            dispatch({
                type: TYPES.SET_TRANSACTIONS,
                transactions
            })
        }
    }

    static setNoTransactions() {
        return (dispatch, getState) => {
            dispatch({
                type: TYPES.SET_NO_TRANSACTIONS
            });
        };
    }

    static fetchTransactions(
        period = 'current',
        unit = 'week'
    ) {
        return (dispatch, getState) => {
            let state = getState()

            const offsetKeyDate = state[this.NAME].hasIn(['offsetKeyDate'])
                                    ? state[this.NAME].getIn(['offsetKeyDate']).toJS()
                                    : null

            let dataPeriod = !offsetKeyDate || !offsetKeyDate.date
                                    ? billingPeriod(moment().format('L'), unit)
                                    : offsetKeyDate

            if ('prev' === period) {
                dataPeriod = billingPeriod(moment(dataPeriod.date, 'L').subtract(1, unit).format('L'), unit)
            } else if ('next' === period) {
                dataPeriod = billingPeriod(moment(dataPeriod.date, 'L').add(1, unit).format('L'), unit)
            }

            dispatch(this.setOffsetKeyDate(dataPeriod))

            let params = {
                count: 1000,
                pub_date__gte: dataPeriod.start,
                pub_date__lte: dataPeriod.end
            };

            dispatch(DashboardReducer.setLoading())

            return capi.Income.retrieve(
                null,
                params
            ).then((res) => {
                apiHandleStatus(res, [200])

                if (res.data.results.length > 0) {
                    dispatch(this.setTransactions(
                        res.data.results.map((r) =>{
                            return { ...r, transaction_context: jsonParse(r.transaction_context) }
                        }).sort((a, b) => {
                            // Sorting by pub_date
                            // if(a.pub_date < b.pub_date) {
                            //     return -1
                            // } else if (a.pub_date > b.pub_date) {
                            //     return 1
                            // } else {
                            //     return 0
                            // }

                            // Sorting by redemption_date
                            return moment.utc(a.transaction_context.transaction_date).format('X')
                                    - moment.utc(b.transaction_context.transaction_date).format('X')
                        })
                    ))
                } else {
                    dispatch(this.setNoTransactions());
                }

            }).catch((error) => {
                dispatch(DashboardReducer.setError(error))
            })
        }
    }

    static reducer(
        state = DashboardReducer.INITIAL_STATE,
        action
    ) {
        if (state == null) state = DashboardReducer.INITIAL_STATE

        switch (action.type) {
            case MainReducer.TYPES.LOGOUT:
            case TYPES.CLEAR:
                return DashboardReducer.INITIAL_STATE

            case MainReducer.TYPES.SWITCH_CURRENT_IDENTITY:
                action.asyncDispatch(DashboardReducer.fetchTransactions())
                return DashboardReducer.INITIAL_STATE

            case TYPES.SET_LOADING:
                return state.delete('error')
                        .set('loading', true)

            case TYPES.SET_NO_TRANSACTIONS:
                return state.delete('loading')
                        .delete('error')
                        .set('noTransactions', true);

            case TYPES.SET_ERROR:
                return state.delete('loading')
                    .delete('noTransactions')
                    .delete('transactions')
                    .set('error', action.error)

            case TYPES.SET_OFFSET_KEY_DATE:
                return state.set('offsetKeyDate', Immutable.fromJS(action.data))

            case TYPES.SET_TRANSACTIONS:
                return state.delete('loading')
                        .delete('error')
                        .delete('noTransactions')
                        .set('transactions', Immutable.fromJS(action.transactions))

            default:
                return state
        }
    }
}



// WEBPACK FOOTER //
// ./src/containers/dashboard/reducer.js